export default "__VITE_ASSET__DdDUbXsm__"